
import { mapActions, mapGetters } from 'vuex'
import MapTool from '@/components/page/mapTool'
import ChartContainer from '@/components/page/chartContainer'
import MultiPieChartContainer from '@/components/page/multiPieChartContainer'
import benchmarkBuilder from '@/components/page/benchmarkBuilder'
import { capitalize, htmlize } from '@/utils/StringUtils'

export default {
  name: 'DataContent',
  components: { MapTool, ChartContainer, MultiPieChartContainer, benchmarkBuilder },
  computed: {
    ...mapGetters({
      pageContent: 'page/pageContent',
      mapContent: 'page/mapContent',
      benchmarkRegions: 'page/benchmarkRegions',
      mapRegion: 'page/mapRegion',
      world: 'world',
      scenariosContent: 'scenariosContent',
      isMobileLayout: 'isMobileLayout'
    }),
    mapUnitName () {
      return this.$options.filters.unitName(this.mapContent.displayUnit)
    },
    isNotWorldDisplay () {
      return this.benchmarkRegions.length > 0 || this.mapRegion !== this.world
    },
    selectedCountriesTitle () {
      if (this.benchmarkRegions.length > 0) {
        return ''
      }
      return this.mapRegion['name' + capitalize(this.$i18n.locale)]
    },
    graph2Exist () {
      return this.pageContent.graph2 !== undefined && this.benchmarkRegions.length === 0
    },
    graph2Title () {
      return this.pageContent.graph2.titre.replace('{{countrySelected}}', this.selectedCountriesTitle)
    },
    keyText () {
      return this.renderText(this.$md.renderInline(this.pageContent.keys.data.text))
    },
    tagline () {
      return this.renderText(this.$md.renderInline(this.pageContent.tagline))
    },
    analyse () {
      return this.renderText(this.$md.renderInline(this.pageContent.analyse))
    }
  },
  methods: {
    ...mapActions({
      clearMapRegion: 'page/clearMapRegion',
      clearBenchmarkRegions: 'page/clearBenchmarkRegions'
    }),
    handleBenchmarkClick () {
      this.$bvModal.show('benchmark-modal')
    },
    displayWorld () {
      this.clearMapRegion()
      this.clearBenchmarkRegions()
    },
    renderText (s) {
      return htmlize(s).replace('href="', 'target ="_blank" href="').replace(/<strong\b[^>]*>(.*?)<\/strong>/g, '<span class="keyText">$1</span>')
    }
  }
}
